import React, {Component} from 'react';
import _ from 'lodash';
import {connect} from 'react-redux';
import {Field, FieldArray, getFormValues, reduxForm} from 'redux-form';
import {commonRenderInput} from '../common/access-form';
import {maxLength32, validateNull, verifyForm} from '../common/access-form-validation';
import {Button, Col, Row} from 'react-bootstrap';
// import FieldFileInput from '../common/FieldFileInput';
import Loading from '../../components/common/Loading';
import {checkTableAuth} from '../common/access-auth';
import {closeModal, openModalAlert, openPickModal, popupModalConfirm} from '../../actions/index';
import {dispatchPickGroup} from '../../actions/model/index'
import {dispatchSaveVisualManager, getVisualGroupInteriorGraphAction, doGetFloorPlanProjectList} from '../../actions/visual/index'
import { saveVisualManagerDataList} from '../../actions/visual/visual-data';
// import { uploadFile } from '../../components/common/common-data';
import DropzoneComponent from '../../components/common/dropzoneField';
import Dropdown from 'react-bootstrap/Dropdown';
// import { getUploadFile } from '../../components/common/common-data';
import moment from 'moment';

const formData = new FormData();
class VisualManagerForm extends Component {

    constructor(props) {
        super(props);

        this.state = {
            reUploadImg:props.modalMessage === 'add',
            visualImageDisplay: true,
            optionValues: null,
            listImgs: [],
            selectedIndex: 0,
            anyImageRemoved: false,
        }
        this.visualImage = new File([""], null);
    }

    setAnyImageRemoved = () => {
        this.setState({anyImageRemoved: true});
    }

    getInteriorImage = () => {
        // const { authToken, getVisualGroupInteriorGraphAction, detail, interiorGraphImgUrl, change } = this.props;
        // let updLoadPromise = new Promise((resolve, reject) => {
        //     getUploadFile(resolve, reject, detail.fileName, authToken);
        // })
        // updLoadPromise.then((blobRes) => {
        //     const blob = URL.createObjectURL(blobRes)
        //     let img = new Image();
        //     img.src = blob
        //     img.onload = () => {
        //         getVisualGroupInteriorGraphAction(interiorGraphImgUrl, img.width, `url("` + blob + `")`);
        //     }
        // })
        
    }
    // convert any data url to a file 
    dataURLtoFile(dataurl, filename) {
        var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
        while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
        }
        return new File([u8arr], filename, { type: mime });
    }

    verify = (formListImages) => {
        const { listImgs } = this.state;
        let pass = true;

        if (formListImages.length < listImgs.length || !this.verifyField(formListImages) || listImgs.length === 0) {
            pass = false;
        }

        return pass;
    }

    verifyField = (formListImages) => {
        let fieldPass = true;

        for(let i = 0; i < formListImages.length; i++) {
            if(formListImages[i] === undefined || formListImages[i]?.name === '' || formListImages[i]?.name === null
                ||formListImages[i]?.name === undefined || formListImages[i]?.name.trim().length === 0) {
                fieldPass = false;
            }

            if((formListImages[i]?.name && formListImages[i]?.name.length > 32) || (formListImages[i]?.description && formListImages[i]?.description.length > 32)) 
                fieldPass = false;
        
            for(let j = i+1; j < formListImages.length; j++) {
                if(formListImages[i]?.name === formListImages[j]?.name) {
                    fieldPass = false;
                    break;
                }
            }
        }
        return fieldPass;
    }

    saveVisualManagerDetail = () => {

        const { verifyFormPass, formValues, popupModalConfirm, modalMessage, authToken, dispatchSaveVisualManager, accountRole, roleTableAuth, closeModal, openModalAlert, detail, doGetFloorPlanProjectList, selectSite } = this.props;
        const { listImgs } = this.state;

        const listImages = formValues.listImages;

        const verifyForm = modalMessage === 'add-multi-floor' ? this.verify(listImages) : verifyFormPass;

        if (checkTableAuth('rf_map', accountRole, roleTableAuth, 2)) {
            if (verifyForm) {
                let saveBodyData = [];
                if (formValues.id) {
                    if (this.state.anyImageRemoved) {
                        if (!listImages[0]?.interiorGraphImg) {
                            openModalAlert("Please upload the floor plan image.")
                            return
                        }
                    } else { // The image is not changed
                        const imageFile = this.dataURLtoFile(`data:image/png;base64,${detail?.interiorImg}`, detail.fileName);
                        const previewUrl = `data:image/png;base64,${detail?.interiorImg}`;
                        imageFile.preview = previewUrl;
                        listImages[0].interiorGraphImg = {file: imageFile, preview: previewUrl};    
                    }
                }

                if (listImages) {
                    listImages.forEach(image => {
                        let element = {...image};

                        if (modalMessage === 'upd') {
                            element = _.omit(formValues, ['longitude', 'reBind', 'latitude', 'createdDate', 'createdBy', 'lastUpdatedDate', 'lastUpdatedBy', 'listImages']);
                        }

                        element.floorPlanId = formValues.floorPlanId;

                        if (image.interiorGraphImg.file) {
                            image.interiorGraphImg.file.preview = image.interiorGraphImg.preview;
                            image.interiorGraphImg = image.interiorGraphImg.file;
                        }

                        if (image && image.interiorGraphImg) {
                            element.fileName = image.interiorGraphImg.name;
                            element.fileType = image.interiorGraphImg.type;
                            element.interiorGraphImg = image.interiorGraphImg;
                        } else if (image.interiorGraphImg === null && detail?.interiorImg && this.state.visualImageDisplay) {
                            element.fileName = detail.fileName;
                            element.fileType = "image/png";
                            formValues.interiorGraphImg = this.dataURLtoFile(`data:image/png;base64,${detail?.interiorImg}`, detail.fileName);
                        }
                        saveBodyData.push({...element});
                    });

                    const validExts = ["image/jpg", "image/png", "image/jpeg"];

                    saveBodyData.forEach((imageItem) => {
                        if (imageItem && validExts.indexOf(imageItem.fileType) < 0 && !this.state.visualImageDisplay) {
                            openModalAlert("File exts error, accept exts is " + validExts.toString());
                        }
                        else if (!formData || imageItem.interiorGraphImg === null) {
                            openModalAlert("Please upload floor image.")
                        }
                    });

                    popupModalConfirm('Confirm', 'icon-alert', 'Confirm to save change ?', 300, () => {
                        let promises = saveBodyData.map((imageItem) => {
                            return new Promise((resolve, reject) => {
                              const { preview, rotation = 0 } = imageItem.interiorGraphImg;
                              
                              if (!preview) {
                                resolve();
                                return;
                              }
                          
                              const image = new Image();
                              image.crossOrigin = "Anonymous";
                              image.src = preview;
                              
                              image.onload = () => {
                                try {
                                  const angle = (rotation || 0) % 360;
                                  const canvas = document.createElement('canvas');
                                  const ctx = canvas.getContext('2d');
                              
                                  if (angle === 90 || angle === 270) {
                                    canvas.width = image.height;
                                    canvas.height = image.width;
                                  } else {
                                    canvas.width = image.width;
                                    canvas.height = image.height;
                                  }
                              
                                  ctx.save();

                                  switch (angle) {
                                    case 90:
                                      ctx.translate(canvas.width, 0);
                                      ctx.rotate(Math.PI / 2);
                                      break;
                                    case 180:
                                      ctx.translate(canvas.width, canvas.height);
                                      ctx.rotate(Math.PI);
                                      break;
                                    case 270:
                                      ctx.translate(0, canvas.height);
                                      ctx.rotate(3 * Math.PI / 2);
                                      break;
                                    default:
                                      break;
                                  }
                              
                                  ctx.drawImage(image, 0, 0);
                                  ctx.restore();
                              
                                  const dataURL = canvas.toDataURL('image/jpeg', 0.8);
                                  imageItem.interiorImg = dataURL.split(',')[1];
                                  resolve();
                                } catch (err) {
                                  reject(new Error("Canvas processing error: " + err.message));
                                }
                              };
                          
                              image.onerror = (e) => {
                                reject(new Error(`Failed to load image: ${e.type}`));
                              };
                            });
                          });
                        Promise.all(promises).then (() => {
                            let savePromise = new Promise((resolve, reject) => {
                                saveVisualManagerDataList(resolve, reject, saveBodyData, modalMessage, authToken);
                            });
                            savePromise.then((data) => {
                                if (data.responseMsg === 'success') {
                                    closeModal(null);
                                    dispatchSaveVisualManager(saveBodyData, authToken);
                                    doGetFloorPlanProjectList(authToken, selectSite);
                                }
                                else {
                                    openModalAlert(data.responseMsg);
                                }
                            });
                        })
                    }, null, false);
                }
            } else {
                if (modalMessage === 'upd') {
                    openModalAlert("Please input the floor plan name.")
                } else if (listImgs.length === 0) {
                    openModalAlert("Please upload the floor plan.");
                } else { 
                    const baseFloorNumber = this.props.visualListId?.mappingGroups?.length || 0;
                    for (let i = 0; i < listImages.length; i++) {
                        const currentName = listImages[i]?.name || '';
                        for(let j = i + 1; j < listImages.length; j++) {
                            const nextName = listImages[j]?.name || '';
                            if(currentName === nextName && currentName !== '') {
                                openModalAlert(`Floor plan name "${currentName}" is duplicated between Floor ${baseFloorNumber + i + 1} and Floor ${baseFloorNumber + j + 1}.`);
                                return;
                            }
                        }
                        
                        // Check if the floor plan name is missing or empty
                        const floorItem = listImages[i];
                        const floorName = floorItem?.name;
                        const isEmpty = !floorName || floorName.trim() === '';
                        
                        if (isEmpty) {                            
                            openModalAlert(`Please input name for Floor ${baseFloorNumber + i + 1}`);
                            break;
                        }
                        else if(floorName.length > 32) {                            
                            openModalAlert(`Floor ${baseFloorNumber + i + 1} has name longer than 32 characters`);
                            break;
                        }
                        else if(floorItem?.description && floorItem.description.length > 32) {           
                            openModalAlert(`Floor ${baseFloorNumber + i + 1} has description longer than 32 characters`);
                            break;
                        }
                        else if (i < listImgs.length) {                            
                            openModalAlert(`Please input name for Floor ${baseFloorNumber + i + 2}`);
                        }
                    }
                }
            }
        }else {
            openModalAlert("Sorry, you don't have permission to change config.");
        }
    }
    checkBackgroundImage = (img) => {
        const {listImgs} = this.state;

        if (JSON.stringify(listImgs) !== JSON.stringify(img)) {
            setTimeout(() => {
                this.setState({listImgs: img});
            }, 0);
        }

        if (img.length > 0) {
            formData.delete("visualImage");
            formData.append('visualImage', img[0]);
        } else {
            formData.delete("visualImage");
        }
    }

    checkBackgroundMultiImage = (img) => {
        const {listImgs} = this.state;

        if (JSON.stringify(listImgs) !== JSON.stringify(img)) {
            setTimeout(() => {
                this.setState({listImgs: img});
            }, 0);
        }
    }

    componentDidMount() {
       
    }

    isLastElement(array, element) {
        return array[array.length - 1] === element;
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        const { detail, change, formValues, floorPlanCount } = this.props;
        const { selectedIndex, listImgs } = this.state;

        if (prevProps.detail !== detail) {
            this.getInteriorImage();
        }

        if (prevState.listImgs !== listImgs) {
            for (let i = 0; i < listImgs.length; i++) {
                if (formValues?.listImages[i]?.name === null || formValues?.listImages[i]?.name === undefined) {
                    change(`listImages[${i}].name`, `Floor ${ floorPlanCount + i + 1}`)
                    change(`listImages[${i}].interiorGraphImg`, listImgs[i]);
                }
            }
        }

        // Remove image from list
        if (prevState.listImgs !== this.state.listImgs && this.state.listImgs.length < formValues?.listImages.length) {

            const listImages = formValues?.listImages;

            let newListImages;

            let element = listImages.filter(img => !listImgs.includes(img.interiorGraphImg));

            if (this.isLastElement(listImages, element[0]) && listImages.length === 1) {
                newListImages = listImages;
            } else {
                newListImages = listImages.filter(img => listImgs.includes(img.interiorGraphImg));
            }

            if (this.isLastElement(listImages, element[0]) && listImgs.length > 0) {
                this.setState({selectedIndex: this.state.selectedIndex - 1});
            }

            change("listImages", newListImages);
        }

        if (prevProps.selectedIndex !== selectedIndex && listImgs.length > 0) {
            const newImage = listImgs[selectedIndex];
            change(`listImages[${selectedIndex}].interiorGraphImg`, newImage);
        } else {
            change(`listImages[${selectedIndex}].interiorGraphImg`, null);
        }

        if (listImgs.length > 0) {
            change('interiorGraphImg', listImgs[0]);
        } else {
            change('interiorGraphImg', null);
        }

    }

    render() {
        const { detail, handleSubmit, readOnly, modalMessage, closeModal, openModalAlert, managerDetail, isLoading } = this.props;
        const { selectedIndex } = this.state;

        if (isLoading) {
            return <Loading loading={true}></Loading>
        }
        if (detail && modalMessage !== 'view') {
            return (
                <div className='area-form form-custom'>
                    <form onSubmit={handleSubmit(this.saveVisualManagerDetail)}>
                        <div className='area-content'>
                            <div className='area-header'>
                                <label>Basic Info</label>
                            </div>
                            <div className='line'></div>
                            <div className='area-body'>
                                <Row>
                                    <Col sm={12}>
                                        <div className='area-form-label'>
                                            {readOnly ? null : <label className='need-star-label'>*</label>}
                                            <label>Floor Plan Name</label>
                                        </div>
                                    </Col>

                                    <Col sm={12}>
                                        <div className='area-form-field'>
                                            <Field name="name" type="text" placeholder="Please input floor plan name" component={commonRenderInput} validate={[maxLength32, validateNull]} disabled={readOnly} />
                                        </div>
                                    </Col>

                                    <Col sm={12}>
                                        <div className='area-form-label'>
                                            <label>Description </label>
                                        </div>
                                    </Col>
                                    {/* <Row className='row-line'> */}
                                    <Col sm={12}>
                                        <div className='area-form-field'>
                                            <Field name="description" type="text" placeholder="Please input description" validate={maxLength32} component={commonRenderInput} disabled={readOnly} />
                                        </div>
                                    </Col>
                                    {/* </Row> */}
                                </Row>
                                {/* <span style={{fontFamily: 'Roboto', fontSize: '12px', marginLeft: '12px'}}>{formValues?.interiorGraphImg?.name ?? detail.fileName}</span> */}

                                <div className='area-body-border'>
                                    <div className='area-img'>
                                        <DropzoneComponent callback={this.checkBackgroundImage}
                                                           title="Upload floor plan"
                                                           subTitle="Or drag and drop file (JPG, PNG or PDF)"
                                                           type="large"
                                                           setAnyImageRemoved={this.setAnyImageRemoved}
                                                           interiorGraphImgUrl={managerDetail?.interiorImg}
                                                           openModalAlert={openModalAlert}
                                                           />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <hr />
                        <div className='area-btns'>
                            <div className='area-btn-cancel'>
                                <Button type="" variant="primary" bsPrefix='btn btn-cancel' onClick={() => closeModal(null)}>Cancel</Button>
                            </div>
                            {modalMessage === 'add' ? <div className='area-btn-create'>
                                <Button type="submit" variant="primary" bsPrefix='btn btn-create' >Create</Button>
                            </div> : <div className='area-btn-create'>
                                <Button type="submit" variant="primary" bsPrefix='btn btn-create' >Confirm</Button>
                            </div>}
                        </div>
                    </form>
                </div>
            )

        }
        else if (detail && modalMessage === 'view') {
            return (
                <div className='area-form form-custom'>
                    <form onSubmit={handleSubmit(this.saveVisualManagerDetail)}>
                        <div className='area-content'>
                            <div className='area-header'>
                                <label>Basic Info</label>
                            </div>
                            <div className='title-line'></div>
                            <div className='area-body'>
                                <Row>
                                    <Col sm={3}>
                                        <div className='area-form-label'>
                                            {readOnly ? null : <label className='need-star-label'>*</label>}
                                            <label>Floor Plan Name </label>
                                        </div>
                                    </Col>
                                    <Col>
                                        <div className='area-form-field-view'>
                                            <Field style={{ textAlign: 'right' }} name="name" type="text" placeholder="Input name" component={commonRenderInput} disabled={readOnly} />
                                        </div>
                                    </Col>
                                </Row>
                                <div className='line-content'></div>

                                <div className='line-content'></div>
                                <Row>
                                    <Col>
                                        <div className='area-form-label'>
                                            <label>Description </label>
                                        </div>
                                    </Col>
                                    <Col>
                                        <div className='area-form-field-view'>
                                            <Field name="description" type="text" component={commonRenderInput} disabled={readOnly} />
                                        </div>
                                    </Col>
                                </Row>
                                <br />
                                <div className='line-content'></div>
                                <Row style={{ display: modalMessage !== 'add' ? 'flex' : 'none' }}>
                                    <Col>
                                        <div className='area-form-label'>
                                            <label>Created Date </label>
                                        </div>
                                    </Col>
                                    <Col>
                                        <div className='area-form-field-view'>
                                            <Field name="createdDate" type="text" component={commonRenderInput} disabled={true} />
                                        </div>
                                    </Col>
                                </Row>
                                <div className='line-content'></div>
                                <Row style={{ display: modalMessage !== 'add' ? 'flex' : 'none' }}>
                                    <Col>
                                        <div className='area-form-label'>
                                            <label>Created By </label>
                                        </div>
                                    </Col>
                                    <Col>
                                        <div className='area-form-field-view'>
                                            <Field name="createdBy" type="text" component={commonRenderInput} disabled={true} />
                                        </div>
                                    </Col>
                                </Row>
                                <div className='line-content'></div>
                                <Row style={{ display: modalMessage !== 'add' ? 'flex' : 'none' }}>
                                    <Col>
                                        <div className='area-form-label'>
                                            <label>Last Updated Date </label>
                                        </div>
                                    </Col>
                                    <Col>
                                        <div className='area-form-field-view'>
                                            <Field name="lastUpdatedDate" type="text" component={commonRenderInput} disabled={true} />
                                        </div>
                                    </Col>
                                </Row>
                                <div className='line-content'></div>
                                <Row style={{ display: modalMessage !== 'add' ? 'flex' : 'none' }}>
                                    <Col>
                                        <div className='area-form-label'>
                                            <label>Last Updated By </label>
                                        </div>
                                    </Col>
                                    <Col>
                                        <div className='area-form-field-view'>
                                            <Field name="lastUpdatedBy" type="text" component={commonRenderInput} disabled={true} />
                                        </div>
                                    </Col>
                                </Row>
                                <div className='line-content'></div>
                            </div>
                        </div>
                        <br />
                        <div className='area-content'>
                            <div className='area-header'>
                                <label>Floor Plan</label>
                            </div>
                            <div className='title-line'></div>
                            <div className='area-body'>
                                <div className='area-body-border'>
                                    <div className='area-img'>
                                        {managerDetail?.interiorImg ? <><div className='visual-image-view' style={{ backgroundImage: `url('data:image/png;base64,${managerDetail?.interiorImg}')` }}></div></> : ''}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            )
        }
        else if (modalMessage === 'add-multi-floor') {
            return (
                <div className='area-form form-custom'>
                    <form onSubmit={handleSubmit(this.saveVisualManagerDetail)}>

                        <div className='area-content'>
                            <div className='area-header'>
                                <label>Basic Info</label>
                            </div>
                            <div className='line' style={{width:'80%'}}></div>

                            <div className='area-body'>

                                {
                                    this.renderDropdown()
                                }

                                <FieldArray
                                    id="import-floor-plan"
                                    name="listImages"
                                    component={this.renderFormField}
                                    selectedIndex={selectedIndex}
                                    readOnly={readOnly}
                                />

                                <div style={{height: '100%'}}>
                                    <div id="import-floor-plan-image" className='area-img'>
                                        <DropzoneComponent
                                            id="import-floor-plan-upload-btn"
                                            callback={this.checkBackgroundMultiImage}
                                            title="Upload floor plan"
                                            subTitle="Or drag and drop file (JPG, PNG or PDF)"
                                            type="large"
                                            modalMessage={modalMessage}
                                            index={selectedIndex}
                                            openModalAlert={openModalAlert}
                                        />
                                    </div>
                                </div>
                            </div>

                        </div>

                        <hr/>
                        <div className='area-btns'>
                            <div className='area-btn-cancel'>
                                <Button id="import-floor-plan-cancel-btn" type="" variant="primary" bsPrefix='btn btn-cancel'
                                        onClick={() => closeModal(null)}>Cancel</Button>
                            </div>
                            {modalMessage === 'add-multi-floor' ? <div className='area-btn-create'>
                                <Button id="import-floor-plan-create-btn" type="submit" variant="primary" bsPrefix='btn btn-create'>Create</Button>
                            </div> : <div className='area-btn-create'>
                                <Button id="import-floor-plan-confirm" type="submit" variant="primary" bsPrefix='btn btn-create'>Confirm</Button>
                            </div>}
                        </div>
                    </form>
                </div>
            )
        } else {
            return (<Loading loading={true}></Loading>);
        }
    }

    renderFormField = ({fields, selectedIndex, readOnly}) => {

        const selectedFloorPlan = fields.get(selectedIndex);

        if (!selectedFloorPlan) {
            return null;
        }

        return (
            selectedFloorPlan &&
            (<div>
                <Row>
                    <Col sm={12}>
                        <div className='area-form-label'>
                            {readOnly ? null :
                                <label className='need-star-label'>*</label>}
                            <label>Floor Plan Name</label>
                        </div>
                    </Col>

                    <Col sm={12}>
                        <div className='area-form-field'>
                            <Field
                                id="import-floor-plan-name"
                                name={`listImages[${selectedIndex}].name`}
                                type="text"
                                placeholder="Please input floor plan name"
                                component={commonRenderInput}
                                disabled={readOnly}
                                validate={[maxLength32, validateNull]}
                            />
                        </div>
                    </Col>

                    <Col sm={12}>
                        <div className='area-form-label'>
                            <label>Description</label>
                        </div>
                    </Col>
                    <Col sm={12}>
                        <div className='area-form-field'>
                            <Field
                                id="import-floor-plan-description"
                                name={`listImages[${selectedIndex}].description`}
                                type="text"
                                placeholder="Please input description"
                                component={commonRenderInput}
                                disabled={readOnly}
                                validate={maxLength32}/>
                        </div>
                    </Col>
                </Row>
            </div>)
        )
    }

    renderDropdown = () => {
        const { listImgs, selectedIndex  } = this.state;
        const { floorPlanCount } = this.props;

        return (
            listImgs.length === 0 ? (
                    <Dropdown className='area-dropdown'>
                        <Dropdown.Toggle className='area-drop-toggle'>
                            Floor {floorPlanCount + selectedIndex + 1}
                        </Dropdown.Toggle>
                    </Dropdown>
            ) : (
                <Dropdown className='area-dropdown'>
                    <Dropdown.Toggle className='area-drop-toggle'>
                        Floor {floorPlanCount + selectedIndex + 1}
                    </Dropdown.Toggle>

                    <Dropdown.Menu className='dropdown-menu' style={{ width: '10px' }}>
                        {listImgs.map((_, index) =>
                            <Dropdown.Item key={index}
                                           className='area-item'
                                           onClick={() => this.handleSelect(index)}> Floor {floorPlanCount + index + 1}</Dropdown.Item>
                        )}
                    </Dropdown.Menu>
                </Dropdown>
            )
    )
    }

    handleSelect = (index) => {
        this.setState({selectedIndex: index});
    }

}

const getverifyField = (visualManagerForm) => {
    if (visualManagerForm) {
        let verifyFields = ['name'];
        if (visualManagerForm.registeredFields?.interiorGraphImg) {
            verifyFields.push('interiorGraphImg');
        }
        return verifyFields;
    }
    else {
        return [];
    }
}

const mapStateToProps = (state) => {
    let modalMessage = state.commonReducers.modalMessage
    const verifyFormPass = verifyForm(state.form['VisualManagerForm'], getverifyField(state.form['VisualManagerForm']))
    let managerDetail = state.visualReducers.managerDetailData;
    let selectFloorPlanProject = state.visualReducers.selectFloorPlanProject;
    const projects = state.visualReducers.floorPlanProjectList ?? JSON.parse(localStorage.getItem('floorPlanProjectList'));
    const selectedProject = projects.find(project => project.seq === parseInt(selectFloorPlanProject));
    let result = {
        accountInfo: state.loginReducers.accountInfo,
        authToken: state.loginReducers.authToken,
        accountRole: state.loginReducers.accountRole,
        roleTableAuth: state.loginReducers.roleTableAuth,
        modalMessage: modalMessage,
        modalStatus: state.commonReducers.status,
        modalPick: state.commonReducers.modalPick,
        detail: managerDetail,
        readOnly: modalMessage === 'view',
        verifyFormPass: verifyFormPass,
        formValues: getFormValues('VisualManagerForm')(state),
        loading: false,
        interiorGraphImgUrl: managerDetail?.interiorImg,
        managerDetail: state.visualReducers.managerDetail,
        interiorGraphImgUrlDetail: state.visualReducers.interiorGraphImgUrlDetail,
        selectSite: state.siteReducers.selectSite,
        groupListByOrg: state.modelReducers.groupListByOrg,
        // groupId: state.modelReducers.groupId
        groupId: state.visualReducers.managerDetailData?.group,
        visualList: state.visualReducers.visualList,
        visualListId: state.visualReducers.visualListId,
        floorPlanCount: parseInt(selectedProject?.floorPlanCount ?? 0),
        isLoading: state.visualReducers.isLoading
    }


    if (managerDetail) {
        let initialValues = {};
        initialValues['id'] = managerDetail['id'];
        initialValues['name'] = managerDetail['name'];
        initialValues['reBind'] = false;
        initialValues['description'] = managerDetail['description'];
        initialValues['longitude'] = managerDetail['longitude'];
        initialValues['latitude'] = managerDetail['latitude'];
        initialValues['width'] = managerDetail['width'];
        initialValues['height'] = managerDetail['height'];
        initialValues['scale'] = null;
        initialValues['fileName'] = managerDetail['fileName'];
        initialValues['createdDate'] = moment(managerDetail['createdDate']).format('YYYY-MM-DD HH:mm:ss');
        initialValues['createdBy'] = managerDetail['createdBy'];
        initialValues['lastUpdatedDate'] = moment(managerDetail['lastUpdatedDate']).format('YYYY-MM-DD HH:mm:ss');
        initialValues['lastUpdatedBy'] = managerDetail['lastUpdatedBy'];
        initialValues['floorPlanId'] = selectFloorPlanProject;
        result['initialValues'] = initialValues;
    } else {
        let initialValues = {};
        initialValues['floorPlanId'] = selectFloorPlanProject;
        result['initialValues'] = initialValues;
    }

    return result
}

VisualManagerForm = reduxForm({
    form: 'VisualManagerForm',
    enableReinitialize: true
})(VisualManagerForm)

export default connect(
    mapStateToProps,
    { popupModalConfirm, openPickModal, dispatchPickGroup, dispatchSaveVisualManager, closeModal, getVisualGroupInteriorGraphAction, openModalAlert, doGetFloorPlanProjectList }
)(VisualManagerForm)